import { mutations } from "@/constants/state";

export default {
  [mutations.EMPLOYEE_TAGS_FETCH_MUTATION]: (state, payload) => {
    state.employeeTags = payload;
  },
};
